// @flow
import { notifyDanger } from '@gandi/notifications';
import type { NotifyThunkAction } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';

export const useNotifications = (): ({
  notifyMaybeApiError: (
    error: any,
    defaultMessage?: string,
  ) => ReturnType<NotifyThunkAction>,
}) => {
  const { __ } = useTranslator();

  const notifyMaybeApiError = (
    error: any,
    defaultMessage: string = __(
      'An error has occurred. Please try again later.',
    ),
  ) =>
    notifyDanger({
      message:
        (error?.response?.data?.errors || [])[0]?.description ||
        error?.response?.data?.message ||
        defaultMessage,
    });

  // $FlowFixMe[incompatible-return]
  // $FlowFixMe[prop-missing]
  return { notifyMaybeApiError };
};
